<section [attr.aria-labelledby]="mode() + '-report-title'">
  <div class="section-heading">
    <div>
      <h2 [id]="mode() + '-report-title'">Access {{ mode() }}</h2>
    </div>
  </div>

  <div class="workbench">
    <form class="form-surface">
      <label class="toggle-row">
        <input name="manual" type="checkbox" [(ngModel)]="manual">
        <span>Manual input</span>
      </label>

      <div class="form-grid">
        @if (!manual) {
          <div class="form-field full">
            <label for="report-access-key">Lockedspace</label>
            <select id="report-access-key" name="selectedId" class="form-select" [(ngModel)]="selectedId" (ngModelChange)="selectAccessKey()" required>
              <option value="" disabled>Select an access key</option>
              @for (item of accessKeyOptions(); track item.id) {
                <option [value]="item.id">{{ item.label }}</option>
              }
            </select>
          </div>
        } @else {
          <div class="form-field">
            <label for="report-device-id">X-Device-ID</label>
            <input id="report-device-id" name="xDeviceId" class="form-control" [(ngModel)]="xDeviceId" required>
          </div>
          <div class="form-field">
            <label for="report-hash">X-HASH</label>
            <input id="report-hash" name="xHash" class="form-control" [(ngModel)]="xHash" required>
          </div>
        }

        <div class="form-field">
          <label for="report-provider">System provider</label>
          <input id="report-provider" name="systemProvider" class="form-control" [(ngModel)]="systemProvider" [readOnly]="!manual">
        </div>
        <div class="form-field">
          <label for="report-user-id">User ID</label>
          <input id="report-user-id" name="keyUserId" class="form-control" [(ngModel)]="keyUserId" [readOnly]="!manual" required>
        </div>
        <div class="form-field full">
          <label for="report-access-id">Access ID</label>
          <input id="report-access-id" name="accessId" class="form-control" [(ngModel)]="accessId" (ngModelChange)="reportValidationError = ''" [readOnly]="!manual" required>
        </div>
        @if (!manual) {
          <div class="form-field full">
            <label for="report-access-key-value">Access key</label>
            <input id="report-access-key-value" name="accessKey" class="form-control code-input" [(ngModel)]="accessKey" readonly>
          </div>
        }
        @if (manual) {
          <div class="form-field full">
            <label for="report-additional">Additional information</label>
            <textarea id="report-additional" name="additionalInfo" rows="5" class="form-control code-input" [(ngModel)]="additionalInfo"></textarea>
          </div>
        }
        @if (mode() === 'event') {
          <div class="form-field full">
            <span id="report-event-label" class="field-label">Event</span>
            <div class="report-options" role="group" aria-labelledby="report-event-label" [attr.aria-busy]="activeReport !== undefined">
              @for (item of events; track item) {
                <button
                  type="button"
                  [class.active]="activeReport === item"
                  [attr.aria-pressed]="activeReport === item"
                  [disabled]="activeReport !== undefined"
                  (click)="reportEvent(item)"
                >{{ item }}</button>
              }
            </div>
            @if (reportValidationError) {
              <p class="field-error" role="alert">{{ reportValidationError }}</p>
            }
          </div>
        } @else {
          <div class="form-field full">
            <span id="report-deviation-label" class="field-label">Deviation</span>
            <div class="report-options" role="group" aria-labelledby="report-deviation-label" [attr.aria-busy]="activeReport !== undefined">
              @for (item of deviations; track item) {
                <button
                  type="button"
                  [class.active]="activeReport === item"
                  [attr.aria-pressed]="activeReport === item"
                  [disabled]="activeReport !== undefined"
                  (click)="reportDeviation(item)"
                >{{ item }}</button>
              }
            </div>
            @if (reportValidationError) {
              <p class="field-error" role="alert">{{ reportValidationError }}</p>
            }
          </div>
        }
      </div>

    </form>

    <div>
      <app-api-endpoint [endpoint]="endpoint()" />

      <aside class="guidance-panel" aria-label="Access report instructions">
        @if (mode() === 'event') {
          <p>Choose a lockedspace to perform access events on.</p>
          <p><strong>Description:</strong> Simulates a driver app interacting with a lock at a lockedspace.</p>
          <p><strong>Expected Result:</strong></p>
          <ul>
            <li><strong>UNLOCK</strong> - Unlocks the compartment and creates an unlock event.</li>
            <li><strong>LOCK</strong> - Locks the compartment and creates a lock event.</li>
            <li><strong>DELIVERED</strong> - Confirms delivery and creates a delivery event.</li>
            <li><strong>PICKEDUP</strong> - Confirms pickup and creates a pickup event.</li>
          </ul>
        } @else {
          <p>Choose a lockedspace and the deviation type to report.</p>
          <p><strong>Description:</strong> Reports driver deviations for the selected lockedspace.</p>
          <ul>
            <li><strong>LockedSpaceNotAccessible</strong></li>
            <li><strong>UnableToLock</strong></li>
            <li><strong>UnableToUnlock</strong></li>
            <li><strong>AccessKeyNotAvailable</strong></li>
            <li><strong>ParcelNotFound</strong></li>
          </ul>
          <p><strong>Expected Result:</strong> The request is accepted successfully.</p>
        }
      </aside>

      <app-api-result
        [endpoint]="endpoint()"
        [showEndpoint]="false"
        [request]="call.request()"
        [response]="call.response()"
        [error]="call.error()"
      />
    </div>
  </div>
</section>